import React from "react";
import { sanitizeHtml } from "../../../utils/sanitizeHtml";

type SafeHtmlProps = React.HTMLAttributes<HTMLDivElement> & {
  html?: string | null;
};

const SafeHtml = ({ html, ...props }: SafeHtmlProps) => {
  return (
    <div
      {...props}
      dangerouslySetInnerHTML={{ __html: sanitizeHtml(html) }}
    />
  );
};

export default SafeHtml;
